import { UnifiedAgentProvider } from 'pages/chatbot/ui/UnifiedAgent'
import { ChatbotNewV2Page } from 'pages/chatbot/pages/chatbotNew/ui/ChatbotNewV2Page'

export const ChatbotNewV2Layout = () => (
  <UnifiedAgentProvider agentId={null}>
    <ChatbotNewV2Page />
  </UnifiedAgentProvider>
)
